import { render, staticRenderFns } from "./DirectoryReassignModal.vue?vue&type=template&id=be95d8fa&scoped=true&"
import script from "./DirectoryReassignModal.vue?vue&type=script&lang=js&"
export * from "./DirectoryReassignModal.vue?vue&type=script&lang=js&"
import style0 from "./DirectoryReassignModal.vue?vue&type=style&index=0&id=be95d8fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be95d8fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be95d8fa')) {
      api.createRecord('be95d8fa', component.options)
    } else {
      api.reload('be95d8fa', component.options)
    }
    module.hot.accept("./DirectoryReassignModal.vue?vue&type=template&id=be95d8fa&scoped=true&", function () {
      api.rerender('be95d8fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/directories/DirectoryReassignModal.vue"
export default component.exports